import React, { useEffect} from 'react'
import http from './../../services/Api'
import swal from 'sweetalert';

import './index.css';
import {
    useParams
} from "react-router-dom";

export default function EmailConfirmation(){
    const { token } = useParams();

    useEffect(() => {
        verifyAccount()
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    async function verifyAccount(){
        try {
            const response = await http.get(`/api/verify-email/${token}`)
            if(response.data.confirmed === true){
                console.log('VALIDADO');
            }else{
                console.log('TOKEN EXPIRADO')
            }
        } catch (e) {
            swal('Erro!', "usuário não encontrado", "error")
        }
    }

    return (
        <div>
            wololo
        </div>
    );
}